import type { Product, Flavour, TasteVideo } from '../domain/models';
import type { FlavourDto, ProductDto, TasteVideoDto } from './dto';

const mapProduct = (dto: ProductDto): Product => {
  return {
    id: dto.id,
    title: dto.title,
    image: dto.image ?? null,
    url: dto.url,
    prominentFlavors: dto.prominent_flavors.map(mapFlavour),
    tasteVideoLandscape: dto.tastewheel_video_landscape ? mapVideo(dto.tastewheel_video_landscape) : null,
    tasteVideoPortrait: dto.tastewheel_video_portrait ? mapVideo(dto.tastewheel_video_portrait) : null,
    tasteGraph: dto.taste_graph,
  };
};

const mapFlavour = (dto: FlavourDto): Flavour => {
  return {
    id: dto.id,
    title: dto.title,
  };
};

const mapVideo = (dto: TasteVideoDto): TasteVideo => {
  return {
    image: dto.image ?? null,
    url: dto.url,
  };
}

const resultsMappers = {
  mapProduct,
};

export default resultsMappers;
